import { Link } from 'react-router-dom';
import { paths } from '../../routes/paths';
import Button from '../../components/ui/Button/Button';
import Icon from '../../components/ui/Icon/Icon';
import styles from './NotFoundPage.module.css';

const ASCII_404 = ` _  _    ___  _  _
| || |  / _ \\| || |
| || |_| | | | || |_
|__   _| | | |__   _|
   | | | |_| |  | |
   |_|  \\___/   |_|  `;

export default function NotFoundPage() {
  return (
    <div className={styles.page}>
      <div className={styles.panel}>
        <div className={styles.kicker}>[ system / 404 ]</div>
        <pre className={styles.ascii} aria-hidden="true">{ASCII_404}</pre>
        <h1 className={styles.title}>page not found</h1>
        <p className={styles.message}>
          &gt; the path you requested does not exist in this filesystem.<br />
          &gt; check the url or head back to safety<span className={styles.caret}>_</span>
        </p>
        <Link to={paths.workspaces} className={styles.linkWrap}>
          <Button
            leftIcon={<Icon name="ArrowLeft" size={14} />}
            variant="primary"
          >
            Back to workspaces
          </Button>
        </Link>
      </div>
    </div>
  );
}
